import { render, staticRenderFns } from "./ContainerReview.vue?vue&type=template&id=731f567f"
import script from "./ContainerReview.vue?vue&type=script&lang=js"
export * from "./ContainerReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports